import { render } from "./LunchCreate.vue?vue&type=template&id=183e08e6"
import script from "./LunchCreate.vue?vue&type=script&lang=js"
export * from "./LunchCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__